import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { NgForm } from "@angular/forms";
import { DateTime } from "luxon";
import { ReceivablesService } from "../../services/receivables.service";
import { Receivable } from "../../model/domain/Receivable";
import { ReceivableStatus } from "../../model/domain/ReceivableStatus";
import { ReceivableFund } from "../../model/domain/ReceivableFund";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

@Component({
  selector: "app-monitor-arquivos",
  templateUrl: "./monitor-arquivos.component.html",
  styleUrls: ["./monitor-arquivos.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ display: "none" })),
      state("expanded", style({ display: "table-row" })),
      transition("expanded <=> collapsed", animate("10ms ease")),
    ]),
  ],
})
export class MonitorArquivosComponent implements OnInit {
  constructor(private receivablesService: ReceivablesService) {}

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  displayedColumns: string[] = [
    "fileName",
    "processingDate",
    "operationCount",
    "fundName",
    "sequenceNumber",
    "status",
  ];
  displayedDetailColumns: string[] = ["status"];

  Hoje: Date = new Date();
  PeriodoDe: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  PeriodoAte: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  Arquivo = "";
  StatusFilter: number;
  Statuses: ReceivableStatus[] = null;
  FundFilter: number;
  Funds: ReceivableFund[] = null;
  expandedElement: any;

  dataSource: Receivable[] = null;

  defaultPage = 1;
  currentPage = 1;
  defaultSize = 10;
  totalPages: number = null;
  totalItems: number = null;
  listedPages = [];
  firstItemOnPage: number;
  lastItemOnPage: number;

  isExpansionDetailRow = (i: number, row: Object) =>
    row.hasOwnProperty("detailRow");

  ngOnInit() {
    this.getReceivables();

    this.getStatuses();
    this.getFunds();
  }

  clear() {
    this.frm.reset();

    this.PeriodoAte = DateTime.local().toJSDate();
    this.PeriodoDe = DateTime.local().toJSDate();

    this.getReceivables();
  }

  getReceivables(
    page: number = this.defaultPage,
    pageSize: number = this.defaultSize
  ) {
    const params: any[] = [
      this.PeriodoDe,
      this.PeriodoAte,
      this.StatusFilter,
      this.Arquivo,
      this.FundFilter,
      page,
      pageSize,
    ];

    this.receivablesService.GetFiles(...params).subscribe((s) => {
      const rows = [];
      s.results.forEach((element) => {
        rows.push(element, {
          detailRow: true,
          id: element.id,
          history: element.history,
        });
      });

      this.dataSource = rows;
      this.totalPages = s.pageCount;
      this.totalItems = s.rowCount;
      this.firstItemOnPage = s.firstRowOnPage;
      this.lastItemOnPage = s.lastRowOnPage;
      this.currentPage = s.currentPage;
      this.listedPages = [];

      let startPage = this.currentPage - 2;
      if (startPage <= 0) {
        startPage = 1;
      }

      let maxPage = this.currentPage + 2;
      while (maxPage > this.totalPages) {
        maxPage--;
      }

      for (let i = startPage; i <= maxPage; i++) {
        this.listedPages.push(i);
      }
    });
  }

  getStatuses() {
    this.receivablesService.GetStatuses().subscribe((s) => {
      this.Statuses = s;
    });
  }

  getFunds() {
    this.receivablesService.GetFunds().subscribe((s) => {
      this.Funds = s;
    });
  }

  periodoError() {
    if (this.PeriodoAte == null || this.PeriodoDe == null) {
      return true;
    }
    const dateDiff =
      (this.PeriodoAte.getTime() - this.PeriodoDe.getTime()) / 86400000;

    return dateDiff > 30 || dateDiff < 0;
  }

  enviarArquivos() {
    this.receivablesService.SendFiles().subscribe((s) => {});
  }

  receberArquivos() {
    this.receivablesService.ReceiveFiles().subscribe((s) => {});
  }
}
